import { InterfaceComponentOptions, InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ILogic } from './logic.interface';
import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';

/**
 * 用来给纯渲染组件注册业务逻辑
 * 不同场景创建不同的service
 */
export class LogicService {
    private static instance: LogicService;
    public static getInstance(): LogicService {
        if (!LogicService.instance) {
            LogicService.instance = new LogicService();
        }
        return LogicService.instance;
    }


    public logicMap: Map<string, ILogic>;

    public constructor() {
        this.logicMap = new Map();
    }

    public setLogic(factoryOptions: InterfaceFactoryOptions, component: IComponentFactory): void {
        if (!this.getLogic(factoryOptions) && factoryOptions.model.parent?.type !== UIModelType.SMART_ART) {
            const service = this.createLogic(factoryOptions, component);
            if (service) {
                this.logicMap.set(factoryOptions.model.key, service);
                service.init();
            }
        }
    }

    public getLogic(factoryOptions: InterfaceFactoryOptions): ILogic | undefined {
        return this.logicMap.get(factoryOptions.model.key);
    }

    public removeLogic(factoryOptions: InterfaceFactoryOptions): void {
        const logic = this.logicMap.get(factoryOptions.model.key);
        logic?.dispose();
        this.logicMap.delete(factoryOptions.model.key);
    }

    // eslint-disable-next-line no-unused-vars
    public createLogic(factoryOptions: InterfaceFactoryOptions, component: IComponentFactory): ILogic | null {
        return null;
    }

    public setComponentLogic(componentOptions: InterfaceComponentOptions, component: IBaseComponent): void {
        if (!this.getComponentLogic(component)) {
            const componentLogic = this.createComponentLogic(componentOptions, component);
            if (componentLogic) {
                this.logicMap.set(component.getUniqueId(), componentLogic);
                componentLogic.init();
            }
        }
    }

    public getComponentLogic(component: IBaseComponent): ILogic | undefined {
        return this.logicMap.get(component.getUniqueId());
    }

    public removeComponentLogic(component: IBaseComponent): void {
        const key = component.getUniqueId();
        const logic = this.logicMap.get(key);
        logic?.dispose();
        this.logicMap.delete(key);
    }

    // eslint-disable-next-line no-unused-vars
    public createComponentLogic(componentOptions: InterfaceComponentOptions, component: IBaseComponent): ILogic | null {
        return null;
    }
}
